import React from 'react';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';

import { rowsPerPageOptions } from '../../config';
import './styles.scss';
import { ColumnDef } from '@tanstack/react-table';
import { IconComponent, icons } from '../../componets/icons';
import { IFormInputPropsFilter } from '../../componets/interfaces/formInputPropsFilter';
import ListComponet from '../../componets/list';
import { IFormSettinsProps } from '../../componets/interfaces/formProps';
import { ImperativeHandleAccessedByParentListComponent } from '../../componets/interfaces/listProps';
import { FormInputProps } from '../../componets/form/formInterfaces';

const defaultValues = {};

const ProductList: React.FC<IFormSettinsProps> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentListComponent>(null);

    const columnsTable = React.useMemo<ColumnDef<object>[]>(
        () => [
            {
                id: 'description',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Descrição
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(row.original.id)
                            }>
                            {row.original?.description}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <IconButton
                            onClick={() =>
                                refForm.current?.handleEdit(row.original.id)
                            }>
                            <IconComponent icon={icons.ModeEdit} />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                refForm.current?.setIdDelete(row.original.id);
                                refForm.current?.setOpenModalDelete(true);
                            }}>
                            <IconComponent icon={icons.Delete} color="error" />
                        </IconButton>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    const QUERY_DEFAULT = `page=1&limit=${rowsPerPageOptions[0]}`;

    const mainInputsFilter = React.useMemo<FormInputProps[]>(
        () => [
            {
                typeInput: 'text',
                name: 'permission.description.ilike',
                control: null,
                label: 'Descrição',
                setValue: null,
                size: 'small',
                variant: 'standard',
                placeholder: 'Pesquisar pelo descrição',
                md: 12,
                handleOnKeyPress: (data: any, name?: string) => {
                    if (data.charCode === 13 && name) {
                        refForm?.current?.handleByOnKeyPressEnterNewQuery(
                            data.target.value,
                            name,
                        );
                    }
                },
            },
        ],
        [],
    );

    return (
        <ListComponet
            settings={settings}
            defaultValues={defaultValues}
            columnsTable={columnsTable}
            inputsFilter={[]}
            mainInputsFilter={mainInputsFilter}
            QUERY_DEFAULT={QUERY_DEFAULT}
            ref={refForm}
            inactiveFilterClean={true}
        />
    );
};

export default ProductList;
